/**
 * Base del backend SIN barra final, apta para concatenar rutas (`${apiBaseUrl()}/api/...`).
 * VITE_API_URL suele configurarse con barra final (axios la necesita), así que aquí se recorta
 * para no generar URLs con `//` en el path.
 */
export function apiBaseUrl(): string {
  const raw = (import.meta.env.VITE_API_URL as string | undefined) ?? "http://localhost:5154/";
  return raw.trim().replace(/\/+$/, "");
}

/** Colapsa `//` accidentales en el path de una URL (sin tocar el `//` del esquema). */
export function normalizeUrl(url: string): string {
  return url.trim().replace(/([^:])\/{2,}/g, "$1/");
}
